<div class="mb-6">
    <app-header [id]="id"></app-header>
</div>

<div class="lg:pt-2 bg-gray-20 lg:border-b border-gray-300">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" rel="stylesheet">

    <div class=" container mx-auto lg:px-16 lg:mb-20 px-3 space-y-4 "
        [ngClass]="isAuthenticated().isAuthenticated ? 'mb-[150px] lg:mb-20' : 'mb-[250px] lg:mb-20'">

        <div class="flex flex-col lg:flex-row gap-4 mb-12 md:mb-20">

            <div class="w-full  space-y-4">

                <h2 class="text-2xl font-bold font-mulish mb-6">Donate an Item </h2>
                <div *ngIf="this.itemDomationConfig() != null && this.itemDomationConfig()!.itemDonationText != ''" class="block font-mulish text-base" [innerHTML]="this.itemDomationConfig()!.itemDonationText">   
                </div>
                <div *ngIf="this.itemDomationConfig() == null" class="flex justify-center items-center h-[245px]">
                    <p-progress-spinner ariaLabel="loading" />
                </div>
                <div *ngIf="this.itemDomationConfig() != null && this.itemDomationConfig()!.itemDonationText == ''">
                    <p class=" hidden md:block font-mulish text-base">Donating items to our auction catalog is a great way
                        to support our
                        fundraising
                        auction effort. We
                        appreciate any items you donate as well as any items you round up and submit on behalf of other
                        donors.</p>
                    <p class=" hidden md:block  font-mulish text-base">
                        To submit an item donation to this auction, you will be asked to provide some information about the
                        item you would like to donate, along with digital pictures of the item if you have any. The auction
                        committee will contact you by email after the item has been reviewed.</p>
                    <p>

                    <p class="block md:hidden font-mulish text-base">
                        Donating items to the auction helps support the fundraising effort. You can donate items yourself or
                        on behalf of others. To submit a donation, provide item details and photos if available. The auction
                        committee will follow up by email after reviewing the submission.</p>
                    <p>
                </div>

            </div>
        </div>

        @if (isAuthenticated().isAuthenticated) {

        <p-stepper #stepper [value]="1" icon="pi pi-user">
            <p-step-item [value]="1" icon="pi pi-user">
                <ng-template pTemplate="indicator">
                    <div class="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center">
                        <i class="pi pi-user"></i>
                    </div>
                </ng-template>
                <p-step class="text-xl font-mulish font-bold"> Donor Information</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <form [formGroup]="donorInfoForm" class="space-y-6  mr-2 ">
                            <div class="flex flex-col md:flex-row md:items-start gap-4 mb-10 lg:mb-20">
                                <label class="font-semibold text-gray-700 md:w-1/4 text-lg">Donor Type</label>

                                <div class="flex flex-col gap-2 md:w-3/4 space-y-3 md:pl-12">


                                    <div *ngFor=" let option of donorTypeOptions" class="flex items-center gap-2">
                                        <p-radioButton name="donorType" [value]="option.value"
                                            inputId="{{ option.value }}" formControlName="donorType"></p-radioButton>
                                        <label [for]="option.value" class="font-mulish ">{{ option.label
                                            }}</label>

                                    </div>
                                    <small class="text-red-500 block min-h-[1rem]"
                                        [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'donorType') }">
                                        {{ getFieldError(donorInfoForm, 'donorType') || '' }}
                                    </small>
                                    <div class="border-t border-gray-300 my-4 w-full"></div>


                                    <div *ngFor="let option of donorTypeCompany" class="flex items-center gap-2">
                                        <p-radioButton name="donorTypeCompany" [value]="option.value"
                                            inputId="{{ option.value }}"
                                            formControlName="donorTypeCompany"></p-radioButton>
                                        <label [for]="option.value" class="font-mulish ">{{ option.label
                                            }}</label>
                                    </div>
                                </div>

                            </div>

                            <div class="flex flex-col md:flex-row md:items-start gap-4 mt-6 lg:mt-10">
                                <div class="flex flex-col gap-2 md:w-1/4">
                                    <label class="font-semibold text-gray-700 text-lg ">Donor Information</label>
                                    <span class="font-mulish text-base">Represents the item's donor. A donor name is
                                        required, while other fields,
                                        including a
                                        website URL for linking the donor’s name or logo, are optional.</span>
                                </div>


                                <div class="flex flex-col gap-2 md:w-3/4 space-y-3 md:pl-12">
                                    <div class="flex flex-col md:flex-row sm:gap-4 mt-4 lg:mt-0">
                                        <div class="flex-1">
                                            <label class="text-base">Donor Name</label>
                                            <input id="donorName" formControlName="donorName"
                                                class="p-inputtext w-full mt-1 border rounded-md px-3 py-2 text-sm" />
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'donorName') }">
                                                {{ getFieldError(donorInfoForm, 'donorName') || '' }}
                                            </small>
                                        </div>
                                        <div class="flex-1">
                                            <label class="text-base">Website</label>
                                            <input id="website" formControlName="website"
                                                class="p-inputtext w-full mt-1 border rounded-md px-3 py-2 text-sm" />
                                        </div>
                                    </div>

                                    <div class="flex flex-col  md:w-3/4 space-y-1">
                                        <label for="imageDonor" class="text-gray-700 font-medium">Logo</label>

                                        <div class="flex flex-col md:flex-row md:items-center gap-4">
                                            <div class="flex items-center gap-4">
                                                <label for="donorImage" [ngClass]="{
    'bg-black text-white flex items-center gap-2 px-4 py-2 rounded cursor-pointer text-sm transition': true,
    'opacity-50 pointer-events-none': donorImageTarget
  }">
                                                    <i class="fas fa-plus-circle text-white "></i>
                                                    Choose
                                                    <input id="donorImage" #donorFileInput type="file" class="hidden"
                                                        formControlName="donorImage" [disabled]="!!donorImageTarget"
                                                        (change)="onFileDonorImageSelected($event)">
                                                </label>
                                                <span class="text-gray-600 text-sm">
                                                    {{ donorImageName || 'No file choosen' }}

                                                </span>
                                            </div>
                                        </div>
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'donorImage') }">
                                            {{ getFieldError(donorInfoForm, 'donorImage') || '' }}
                                        </small>

                                        <div *ngIf="donorImageTarget"
                                            class="flex items-center justify-between py-2 border-b mt-2">
                                            <div class="flex items-center gap-4">
                                                <img [src]="donorImageTarget.src" alt="image"
                                                    class="w-12 h-12 object-cover rounded">
                                                <div>
                                                    <p class="text-sm font-medium">{{donorImageTarget.name}}</p>
                                                    <p class="text-xs text-gray-500">{{donorImageTarget.size}}</p>
                                                </div>
                                            </div>
                                            <i class="pi pi-times text-orange-500 text-xl cursor-pointer"
                                                (click)="removeDonorImage()"></i>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div class="flex flex-col md:flex-row md:items-start gap-4 mt-12  mt-6 lg:mt-10">
                                <div class="flex flex-col gap-2 md:w-1/4">
                                    <label class="font-semibold text-gray-700 text-lg">Donor Contact Information</label>
                                    <span class="font-mulish text-base">Contact Information helps us communicate with
                                        item
                                        donors, so please complete
                                        this section if possible. If you enter information for any of these fields, all
                                        fields become required.</span>
                                </div>


                                <div class="flex flex-col md:w-3/4 md:pl-12 lg:space-y-3 ">


                                    <div class="flex flex-col md:flex-row md:gap-3">
                                        <div class="flex-1">
                                            <label class="font-medium">First Name</label>
                                            <input id="firstName" formControlName="firstName"
                                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm">
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'firstName') }">
                                                {{ getFieldError(donorInfoForm, 'firstName') || '' }}
                                            </small>
                                        </div>
                                        <div class="flex-1">
                                            <label class="font-medium">Last Name</label>
                                            <input id="lastName" formControlName="lastName"
                                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'lastName') }">
                                                {{ getFieldError(donorInfoForm, 'lastName') || '' }}
                                            </small>
                                        </div>
                                    </div>


                                    <div class="flex flex-col md:flex-row md:gap-3">
                                        <div class="flex-1">
                                            <label class="font-medium">Mobile Phone Number</label>
                                            <input id="phone" formControlName="phone"
                                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm">
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'phone') }">
                                                {{ getFieldError(donorInfoForm, 'phone') || '' }}
                                            </small>
                                        </div>
                                        <div class="flex-1">
                                            <label class="font-medium">Email</label>
                                            <input id="email" formControlName="email"
                                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'email') }">
                                                {{ getFieldError(donorInfoForm, 'email') || '' }}
                                            </small>
                                        </div>
                                    </div>


                                    <div class="flex flex-col ">
                                        <label class="font-medium">Address 1</label>
                                        <input id="address1" formControlName="address1"
                                            class="p-inputtext w-full border rounded-md px-3 py-2 text-sm">
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'address1') }">
                                            {{ getFieldError(donorInfoForm, 'address1') || '' }}
                                        </small>

                                        <label class="font-medium lg:mt-3">Address 2</label>
                                        <input id="address2" formControlName="address2"
                                            class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                                    </div>


                                    <div class="flex flex-col ">
                                        <div class="flex-1">
                                            <label for="country" class="font-medium text-base">Country</label>
                                            <p-select id="country" formControlName="country" optionLabel="name"
                                                optionValue="abbreviation" [options]="countries"
                                                class="w-full mt-1"></p-select>
                                        </div>
                                        <div class="flex-1">
                                            <label for="zip" class="font-mulish text-base">{{labelPostalCode}}</label>
                                            <input id="zip" formControlName="zip"
                                                class="p-inputtext w-full text-sm  border rounded-md px-3 py-2 mt-1" />
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'zip') }">
                                                {{ getFieldError(donorInfoForm,'zip') || '' }}
                                            </small>
                                        </div>
                                    </div>


                                    <div class="flex flex-col md:flex-row md:gap-3">
                                        <div class="flex-1">
                                            <label for="city" class="font-medium text-base">City</label>
                                            <input id="city" formControlName="city"
                                                class="p-inputtext w-full border rounded-md px-3 py-2 text-sm" />
                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'city') }">
                                                {{ getFieldError(donorInfoForm, 'city') || '' }}
                                            </small>
                                        </div>
                                        <div class="flex-1">
                                            <label for="state" class="font-mulish text-base">{{labelState}}</label>

                                            <ng-container *ngIf="states.length > 0; else stateTextInput">
                                                <p-select id="state" formControlName="state" class="w-full"
                                                    [options]="states" optionLabel="name" optionValue="abbreviation"
                                                    placeholder="{{placeHolderState}}">
                                                </p-select>
                                            </ng-container>

                                            <ng-template #stateTextInput>
                                                <input id="state" type="text" formControlName="state"
                                                    class="p-inputtext w-full border rounded-md px-3 py-2 text-sm"
                                                    placeholder="Enter your region" />
                                            </ng-template>

                                            <small class="text-red-500 block min-h-[1rem]"
                                                [ngClass]="{ 'invisible': !getFieldError(donorInfoForm, 'state') }">
                                                {{ getFieldError(donorInfoForm, 'state') || '' }}
                                            </small>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div class="mt-4 flex gap-2 ">

                                <button pButton type="button" label="Cancel" (click)="goBack()"
                                    class=" mt-5  h-[35px] !bg-white !border !border-[var(--p-primary-500)] !text-[var(--p-primary-500)]  px-6 py-2 font-medium w-1/2 text-base"
                                    [rounded]="true"></button>

                                <button class="p-button !rounded-2xl w-full h-9 !text-[var(--p-text-color-primary)] mt-5 relative"
                                    (click)="goToSecondStep(activateCallback)">
                                    Next
                                </button>

                            </div>
                        </form>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <p-step-item [value]="2" class="pt-6">
                <p-step class="text-xl font-mulish font-bold">Item Information </p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <form [formGroup]="itemInfoForm" class="space-y-6 mr-2">

                            <div class="flex flex-col md:flex-row md:items-start gap-4">
                                <div class="flex flex-col gap-2 md:w-1/4">
                                    <label class="font-semibold text-gray-700  text-lg">Item Information</label>
                                    <span class="font-mulish text-base">Please describe the item as thoroughly and
                                        accurately as possible. Be sure to
                                        include appealing details about the item to drive up bidding.</span>
                                </div>


                                <div class="flex flex-col gap-2 md:w-3/4 lg:space-y-2 md:pl-12">
                                    <div class="flex flex-col lg:gap-1">

                                        <label class="font-medium">Quantity</label>
                                        <p-inputNumber formControlName="quantity" [showButtons]="true" [step]="1"
                                            [min]="1" class="text-sm w-full" />
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(itemInfoForm, 'quantity') }">
                                            {{ getFieldError(itemInfoForm, 'quantity') || '' }}
                                        </small>

                                        <label class="font-medium">Item Name</label>
                                        <input id="itemName" formControlName="itemName"
                                            class="p-inputtext w-full border rounded-md px-3 py-2 text-sm ">
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(itemInfoForm, 'itemName') }">
                                            {{ getFieldError(itemInfoForm, 'itemName') || '' }}
                                        </small>

                                        <label class="font-medium">Item Description</label>
                                        <textarea id="itemDescription" formControlName="itemDescription" rows="8"
                                            class="p-inputtext w-full border rounded-md px-3 py-2 text-sm">
</textarea>
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(itemInfoForm, 'itemDescription') }">
                                            {{ getFieldError(itemInfoForm, 'itemDescription') || '' }}
                                        </small>

                                        <label class="font-medium">Of Special Note</label>
                                        <!-- <input id="specialNote" formControlName="specialNote"
                                            class="p-inputtext w-full  border rounded-md px-3 py-2 text-sm " /> -->

                                        <textarea id="specialNote" formControlName="specialNote" rows="8"
                                            class="p-inputtext w-full border rounded-md px-3 py-2 text-sm">
</textarea>

                                        <label class="mt-3">Estimated Value</label>
                                        <input id="estimatedValue" formControlName="estimatedValue"
                                            class="p-inputtext w-full  border rounded-md px-3 py-2 text-sm " />
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(itemInfoForm, 'estimatedValue') }">
                                            {{ getFieldError(itemInfoForm, 'estimatedValue') || '' }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-col md:flex-row md:items-start gap-4 mt-6 lg:mt-10">
                                <div class="flex flex-col gap-2 md:w-1/4">
                                    <label class="font-semibold text-gray-700 text-lg">Item Images</label>
                                    <span class="font-mulish text-base">Images can be up to 1MB and can be in any of the
                                        following image formats:
                                        .JPG, .GIF, and .PNG..</span>
                                </div>

                                <div class="flex flex-col gap-2 md:w-3/4 md:pl-12">
                                    <div class="flex flex-col gap-2">

                                        <div class="flex flex-col md:flex-row md:items-center gap-4">
                                            <div class="flex items-center gap-4 mt-4">
                                                <label for="itemImage"
                                                    class="bg-black text-white flex items-center gap-2 px-4 py-2 rounded cursor-pointer text-sm">
                                                    <i class="fas fa-plus-circle text-white "></i>
                                                    Choose
                                                    <input #itemfileInput id="itemImage" type="file" class="hidden"
                                                        (change)="onFileSelected($event)" formControlName="itemImage">
                                                </label>

                                                <span *ngIf="!imagesTarget || imagesTarget.length === 0"
                                                    class="text-gray-600">
                                                    No file chosen
                                                </span>
                                            </div>
                                            <!-- <button pButton type="button" [disabled]="!selectedFile"
                                                (click)="uploadImage()"
                                                class="h-[38px] p-button-info rounded-2xl h-10 text-white flex items-center justify-center gap-2">
                                                <i class="pi pi-upload text-base"></i>
                                                <span class="text-sm">Upload</span>
                                            </button>


                                            <button pButton type="button" [disabled]="!selectedFile"
                                                (click)="cancelItemImage(fileInput)"
                                                class=" h-[38px] bg-gray-100 text-gray-800 rounded ">
                                                <i class="pi pi-times mr-2"></i>
                                                <span class="text-sm">Cancel</span>
                                            </button> -->


                                        </div>
                                        <small class="text-red-500 block min-h-[1rem]"
                                            [ngClass]="{ 'invisible': !getFieldError(itemInfoForm, 'itemImage') }">
                                            {{ getFieldError(itemInfoForm, 'itemImage') || '' }}
                                        </small>
                                        <div *ngFor="let image of imagesTarget"
                                            class="flex items-center justify-between py-2 border-b lg:mt-4">
                                            <div class="flex items-center gap-4">
                                                <img [src]="image.src" alt="image"
                                                    class="w-12 h-12 object-cover rounded">
                                                <div>
                                                    <p class="text-sm font-medium">{{image.name}}</p>
                                                    <p class="text-xs text-gray-500">{{image.size}}</p>
                                                </div>
                                            </div>
                                            <i class="pi pi-times text-orange-500 text-xl cursor-pointer"
                                                (click)="removeImage(image)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 flex gap-2 ">

                                <button pButton type="button" label="Cancel" (click)="goBack()"
                                    class=" mt-5  h-[35px] !bg-white !border !border-[var(--p-primary-500)] !text-[var(--p-primary-500)]  px-6 py-2 font-medium w-1/2 text-base"
                                    [rounded]="true"></button>

                                <button class="p-button !rounded-2xl w-full h-9 !text-[var(--p-text-color-primary)] mt-5 relative"
                                    (click)="goToThirdStep(activateCallback)">
                                    Next
                                </button>

                            </div>
                        </form>
                    </ng-template>
                </p-step-panel>
            </p-step-item>

            <p-step-item [value]="3" class="pt-6">
                <p-step class="text-xl font-mulish font-bold">Delivery Information</p-step>
                <p-step-panel>
                    <ng-template #content let-activateCallback="activateCallback">
                        <form [formGroup]="deliveryForm" class="space-y-6 mr-2">

                            <div class="flex flex-col md:flex-row md:items-start gap-4">
                                <div class="flex flex-col gap-2 md:w-1/4">
                                    <label class="font-semibold text-gray-700 text-lg">Item Delivery</label>
                                    <span class="text-base">Use the 'Additional Info' field to add information the
                                        organization may need
                                        to know (expected delivery date, etc.). This information will only be viewable
                                        by the organization's administrators..</span>
                                </div>
                                <div class="flex flex-col gap-2 md:w-3/4 space-y-3 md:pl-12 mt-4">
                                    <div class="flex flex-col gap-2">

                                        <label class="font-medium">How will you be delivering this item?</label>
                                        <p-select id="delivery" formControlName="delivery" class="w-full text-sm"
                                            [options]=" deliveryOptions"></p-select>

                                        <label class="font-medium">Additional Info</label>
                                        <textarea id="additionalInfo" formControlName="additionalInfo" rows="8"
                                            class="p-inputtext w-full border rounded-md px-3 py-2 text-sm">
</textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-4 flex gap-2 ">
                                <button pButton type="button" label="Cancel" (click)="goBack()"
                                    class=" h-[35px] !bg-white !border !border-[var(--p-primary-500)] !text-[var(--p-primary-500)] mt-5  px-6 py-2 font-medium w-1/2 text-base"
                                    [rounded]="true"></button>
                                <button pButton class=" p-button !rounded-2xl w-full h-9 text-white mt-5 relative "
                                    [disabled]="itemInfoForm.invalid || donorInfoForm.invalid" [rounded]="true"
                                    (click)="onSubmitAll()">
                                    <span class="font-semibold !text-[var(--p-text-color-primary)] text-center w-full text-base ">
                                        Submit
                                    </span>
                                </button>

                            </div>
                        </form>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
        </p-stepper>
        } @else {
        @if (isShowingLoginIframe()) {
        <div class="border border-solid border-[var(--p-primary-500)] rounded-xl ">
            <app-sign-in [loginPage]="loginPage" [loginUrl]="loginUrl()"></app-sign-in>
        </div>
        } @else {
           <div class="flex flex-col md:flex-row items-center  gap-7 md:gap-28
           ">
              
                <button 
                    class="hover:bg-gray-100 text-[var(--p-info-500)] font-mulish w-full h-9 border rounded-2xl border-[var(--p-info-500)]
                    hover:!text-[var(--p-info-600)] hover:!border-[var(--p-info-600)]
                    active:!text-[var(--p-info-700)] active:!border-[var(--p-info-700)] relative" (click)="showLoginIframe()">
                    <fa-icon class="absolute left-3 ml-4"  [icon]="faUser" /> Sign In
                </button>
                <button class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)] 
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)] 
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] !rounded-2xl !w-full h-9 !text-[var(--p-text-color-primary)] relative" (click)="openRegisterModal()">
                    <fa-icon [icon]="faUser" class="absolute left-3 ml-4"  /> Register
                </button>
              
            </div>
        }
        }
    </div>

    <div>
        <app-footer class="pt-10"></app-footer>
    </div>
</div>